import React from 'react';
export default function useCheckAllMessages(supportedLocales, messages) {
  return React.useMemo(function () {
    // Skontroluj ci mame vsetky podporovane jazyky
    var msgLocales = Object.keys(messages);
    var missingLocales = supportedLocales.filter(function (e) {
      return !msgLocales.includes(e);
    });
    return missingLocales.length !== 0 ? new Error("Please provide messages for missing locales: ".concat(missingLocales.join(', '))) : undefined;
  }, [messages, supportedLocales]);
}